module.exports = __webpack_public_path__ + "img/madera004.fc45191d.jpg";